import { useCallback, useEffect, useState } from "react";
import {
  exitPlayerFullscreen,
  isPlayerFullscreenActive,
  requestPlayerFullscreen,
  subscribePlayerFullscreenChange,
} from "./player-fullscreen";

export function usePlayerFullscreen(videoTag) {
  const [, setUiRevision] = useState(0);

  const syncUi = useCallback(() => {
    setUiRevision((n) => n + 1);
  }, []);

  useEffect(() => {
    document.addEventListener("fullscreenchange", syncUi);
    document.addEventListener("webkitfullscreenchange", syncUi);
    const unsubscribe = subscribePlayerFullscreenChange(syncUi);
    return () => {
      document.removeEventListener("fullscreenchange", syncUi);
      document.removeEventListener("webkitfullscreenchange", syncUi);
      unsubscribe();
    };
  }, [syncUi]);

  const isFullscreenUi = isPlayerFullscreenActive();

  const toggleFullscreen = useCallback(() => {
    if (isPlayerFullscreenActive()) {
      exitPlayerFullscreen().finally(syncUi);
      return;
    }
    requestPlayerFullscreen({ videoEl: videoTag }).finally(syncUi);
  }, [videoTag, syncUi]);

  return { isFullscreenUi, toggleFullscreen };
}
